import { useMemo } from 'react';
import useFetchTransactions from './useFetchTransactions';

const useFetchTotals = ({company}) => {
  const { data, loading, error } = useFetchTransactions({company}, 'totals');
  const totals = useMemo(() => {
    if (loading || error) return [];

    // Agrupar datos por año y calcular totales
    const groupedByYear = data.reduce((acc, transaction) => {
      const { datePayed, amount } = transaction;

      // Manejar formato de fecha (DD/MM/YYYY HH:mm)
      const [day, month, year] = datePayed.split(' ')[0].split('/').map(Number);

      // Validar y construir el año
      if (!year || isNaN(year)) return acc;

      // Convertir el monto a número
      const parsedAmount =
        parseFloat(amount.replace(/\./g, '').replace(',', '.')) || 0;

      if (!acc[year]) {
        acc[year] = { year, totalRecaudado: 0, transacciones: 0 };
      }

      // Sumar monto y contar transacción
      acc[year].totalRecaudado += parsedAmount;
      acc[year].transacciones += 1;

      return acc;
    }, {});

    // Convertir el objeto a un array
    return Object.values(groupedByYear);
  }, [data, loading, error]);

  return { totals, loading, error };
};

export default useFetchTotals;
